import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import $ from "jquery";
import { LoginDialogComponent } from '../patients/doctor-profile/components/login-dialog/login-dialog.component';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ShowServicesDialogComponent } from '../patients/doctor-profile/components/show-services-dialog/show-services-dialog.component';
import { Utilities } from '../shared/utilities';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchService } from './search.service';
import { AppService } from '../app.service';
import { AppComponent } from '../app.component';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Response } from 'express';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent implements OnInit, OnDestroy {

  notAvailableText = this?.app?.languageCode == 'en' ? "Not available by the doctor" : "غير متوفرة لدى الطبيب";

  doctors: any[] = [];
  form: FormGroup;
  firstInit: boolean = true

  // lookUps
  healthCareInsurance: any[];
  healthCareInsuranceValue

  languages: any[];
  languagesValues

  medicalServices: any[];
  medicalServicesValue
  // medicalServicesSSR;
  headerTwo: string


  // <for Ng Select>
  genders = [
    { id: 1, name: 'Male' },
    { id: 2, name: 'Female' },
  ];
  gendersAr = [
    { id: 1, name: 'ذكر' },
    { id: 2, name: 'انثى' },
  ];
  gendersValues

  distances = [
    { id: 1, name: 'Closest' },
    { id: 2, name: 'Farest' },
  ];
  distanceValues

  priceRanges = [
    { id: 1, name: 'Low To High' },
    { id: 2, name: 'High To Low' },
  ];
  priceRangeValues

  rates = [
    { id: 1, name: 'Five To Zero' },
    { id: 2, name: 'Zero To Five' },
  ];
  rateValues
  // </for Ng Select>


  LangCode: any

  // Location
  // longitudeValue
  // latitudeValue

  addScrollListener = () => window.addEventListener('scroll', this.onScrolling);
  removeScrollListener = () => window.removeEventListener('scroll', this.onScrolling);

  totalResult: number = 0
  isLoaded: boolean = false;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private service: SearchService,
    public app: AppService,
    public appCop: AppComponent,
    private toaster: ToastrService,
    private dialog: MatDialog,
    @Inject(DOCUMENT) private document: any,
    private cd: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(RESPONSE) private responseExpress: Response
  ) {
    let langServerSideCode = this?.router?.url?.includes('/ar/') ? 'ar' : 'en';
    this.LangCode = isPlatformBrowser(this.platformId) ? this?.app?.languageCode : langServerSideCode
  }

  distance
  rate
  priceRange


  async ngOnInit() {
    this.form = new FormGroup({
      searchText: new FormControl(''),
      insuranceCompanyIds: new FormControl([]),
      gender: new FormControl(undefined),
      // longitude: new FormControl(null),
      // latitude: new FormControl(null),
      languageIds: new FormControl([]),
      rate: new FormControl(undefined),
      priceRange: new FormControl(undefined),
      servicesIds: new FormControl([]),
      locationId: new FormControl(undefined),
      distance: new FormControl(undefined),
      classification: new FormControl(3),
      // locationPlaceholderNotMapped: new FormControl(undefined),
      pageSize: new FormControl(10),
      pageNumber: new FormControl(1),
    });
    await this.getLookUps();

    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
    }
  }

  ngOnDestroy(): void {
    this.cd.markForCheck();
    if (isPlatformBrowser(this.platformId)) {
      this.removeScrollListener();
    }
  }

  get = (formControlName: string) => this.form.get(formControlName) as FormControl;

  checkUrlForParams() {
    let specialtyUrl = this?.route?.snapshot?.paramMap?.get('specialty')
    let country = this?.route?.snapshot?.paramMap?.get('country')
    let city = this?.route?.snapshot?.paramMap?.get('city')
    let area = this?.route?.snapshot?.paramMap?.get('area')
    let insuranceUrl = this?.route?.snapshot?.paramMap?.get('insuranceCompany')

    let adjustUrlTrueGotExecuted: boolean = false
    if (area != 'all-areas' && area != 'جميع-المناطق' && area != null) {
      // .replace(/-/gi, ' ');
      // let areaWithoutHypes = this?.app?.generateSlug(area);
      let areaIdFromLookUp = this.allLocations.find(x => {
        // return x?.name?.replace(/[()،,.]/gi, '').includes(areaWithoutHypes)
        // return this?.app?.generateSlug(x?.name)?.includes(areaWithoutHypes)
        return this?.app?.generateSlug(x?.name) == area
      })
      if (areaIdFromLookUp) {
        this.areaCityIdFromLookUp_Global = areaIdFromLookUp?.id
        this.form.get('locationId').setValue(Number(areaIdFromLookUp?.id));
      } else {
        adjustUrlTrueGotExecuted = true
      }
    } else if (city != 'all-governorates' && city != 'جميع-المحافظات' && city != null) {
      // .replace(/-/gi, ' ');
      // let cityWithoutHyphen = this?.app?.generateSlug(city);
      let cityIdFromLookUp = this.allLocations.find(x => {
        // return x?.name?.replace(/[()،,.]/gi, '').includes(cityWithoutHyphen)
        // return this?.app?.generateSlug(x?.name)?.includes(cityWithoutHyphen)
        return this?.app?.generateSlug(x?.name) == city
      })
      if (cityIdFromLookUp) {
        this.areaCityIdFromLookUp_Global = cityIdFromLookUp?.id
        this.form.get('locationId').setValue(Number(cityIdFromLookUp?.id));
      } else {
        adjustUrlTrueGotExecuted = true
      }
    }
    if (specialtyUrl != 'all-specialities' && specialtyUrl != 'جميع-التخصصات' && specialtyUrl != null) {
      // .replace(/-/gi, ' ');
      // let specialtyUrlWithoutHyphen = this?.app?.generateSlug(specialtyUrl)
      let serviceIdFromUrl = this?.medicalServices?.find(x => {
        // return x?.name?.replace(/[()،,.]/gi, '').includes(specialtyUrlWithoutHyphen)
        // return this?.app?.generateSlug(x?.name)?.includes(specialtyUrlWithoutHyphen)
        return this?.app?.generateSlug(x?.name) == specialtyUrl
      })
      if (serviceIdFromUrl) {
        this.globalSpecialtyUrlWithout_Hyphen = specialtyUrl
        this.form.get('servicesIds').setValue([Number(serviceIdFromUrl?.id)]);
      } else {
        adjustUrlTrueGotExecuted = true
      }
    }
    if (insuranceUrl != 'all-insurance' && insuranceUrl != 'جميع-التأمينات' && insuranceUrl != null) {
      // .replace(/-/gi, ' ');
      // let insuranceUrlWithoutHyphen = this?.app?.generateSlug(insuranceUrl)
      let insuranceIdFromUrl = this?.healthCareInsurance?.find(x => {
        // return x?.name?.replace(/[()،,.]/gi, '').includes(insuranceUrlWithoutHyphen)
        // return this?.app?.generateSlug(x?.name)?.includes(insuranceUrlWithoutHyphen)
        return this?.app?.generateSlug(x?.name) == insuranceUrl
      })
      if (insuranceIdFromUrl) {
        this.form.get('insuranceCompanyIds').setValue([Number(insuranceIdFromUrl?.id)]);
      } else {
        adjustUrlTrueGotExecuted = true
      }
    }

    if (!specialtyUrl || !country || !city || !area || !insuranceUrl) {
      // this.adjustUrl();
      adjustUrlTrueGotExecuted = true
    }

    // handle if language changed in component
    let langSpecialtyUrl = this.isProbablyArabic(specialtyUrl) ? 'ar' : 'en'
    if (this.LangCode != langSpecialtyUrl) {
      this.clearFilters();
      this.adjustUrl();
      setTimeout(() => {
        this.search();
      }, 100);
      return
    }
    // handle if language changed in component

    // handleEncryptedParamsIfThereIsAny
    let params = this.route.queryParams['_value'];
    let str = {};
    let qParams = params?.XYZ
    if (qParams) {
      let qParamsObj = qParams?.split("&&")
      qParamsObj.forEach(element => {
        let m = element.split("=")
        str[Utilities.decrypt(m[0].toString())] = Utilities.decrypt(m[1].toString());
      });
    }
    // || str['insuranceCompanyIds]'
    if (str['searchText']) {
      // if (str['insuranceCompanyIds']) {
      //   let insurance = Number(str['insuranceCompanyIds'])
      //   this.form.get('insuranceCompanyIds').setValue([insurance]);
      // }
      str['searchText'] && this.form.get('searchText').setValue(str['searchText']);
    }
    // handleEncryptedParamsIfThereIsAny
    this.cd.detectChanges();
    setTimeout(() => {
      if (isPlatformServer(this.platformId) && this.responseExpress && adjustUrlTrueGotExecuted == true) {
        // Handles301RedirectsBasedOnDatabaseCondition
        this.J301Redirect();
      }
      this.searchForDoctors()
    }, 100);
  }

  // adjust the url after changing the filter
  adjustUrl(): void {
    // let Lcode = this?.app?.languageCode
    let Lcode = this?.router?.url?.includes('/en/') ? 'en' : 'ar'
    let medicalS = Lcode == 'ar' ? 'جميع-التخصصات' : 'all-specialities'
    let insuranceS = Lcode == 'ar' ? 'جميع-التأمينات' : 'all-insurance'
    let country = Lcode == 'ar' ? 'الأردن' : 'jordan'
    let city = Lcode == 'ar' ? 'جميع-المحافظات' : 'all-governorates'
    let area = Lcode == 'ar' ? 'جميع-المناطق' : 'all-areas'

    if (this?.medicalServicesValue?.length > 0) {
      let a = this.medicalServices.find(x => x.id == this.medicalServicesValue[0])
      medicalS = this?.app?.generateSlug(a?.name);
    }

    if (this?.healthCareInsuranceValue?.length > 0) {
      let a = this.healthCareInsurance.find(x => x.id == this.healthCareInsuranceValue[0])
      insuranceS = this?.app?.generateSlug(a?.name);
    }

    if (this.allLocationsValues) {
      let a = this.allLocations.find(x => x.id == this.allLocationsValues)
      if (a?.parentId == 0) {
        city = this?.app?.generateSlug(a?.name);
      } else if (a?.parentId != 0) {
        city = this?.app?.generateSlug(a?.parentName);
        area = this?.app?.generateSlug(a?.name);
      }
    }

    setTimeout(() => {
      this.router.navigate([`/${this?.app?.languageCode}/search/${medicalS}/${country}/${city}/${area}/${insuranceS}`]);
    }, 100);
  }

  globalSpecialtyUrlWithout_Hyphen = null
  areaCityIdFromLookUp_Global = null
  J301Redirect() {
    // let Lcode = this?.app?.languageCode
    let Lcode = this?.router?.url?.includes('/en/') ? 'en' : 'ar'
    let medicalS = Lcode == 'ar' ? 'جميع-التخصصات' : 'all-specialities'
    let insuranceS = Lcode == 'ar' ? 'جميع-التأمينات' : 'all-insurance'
    let country = Lcode == 'ar' ? 'الأردن' : 'jordan'
    let city = Lcode == 'ar' ? 'جميع-المحافظات' : 'all-governorates'
    let area = Lcode == 'ar' ? 'جميع-المناطق' : 'all-areas'

    if (this.globalSpecialtyUrlWithout_Hyphen) {
      medicalS = this.globalSpecialtyUrlWithout_Hyphen
    }

    if (this.areaCityIdFromLookUp_Global) {
      let a = this.allLocations.find(x => x.id == this.areaCityIdFromLookUp_Global)
      if (a?.parentId == 0) {
        city = this?.app?.generateSlug(a?.name);
      } else if (a?.parentId != 0) {
        city = this?.app?.generateSlug(a?.parentName);
        area = this?.app?.generateSlug(a?.name);
      }
    }

    // const urlRedirectTo = `/${Lcode}/search/${medicalS}/${country}/${city}/${area}/${insuranceS}`;
    const urlRedirectTo = `/${encodeURIComponent(Lcode)}/search/${encodeURIComponent(medicalS)}/${encodeURIComponent(country)}/${encodeURIComponent(city)}/${encodeURIComponent(area)}/${encodeURIComponent(insuranceS)}`;

    if (this.responseExpress) {
      this.responseExpress.set('location', urlRedirectTo);
      this.responseExpress.setHeader('Content-Type', 'text/plain');
      this.responseExpress.statusCode = 301;
    } else {
      console.error('Response object is not available REEEEEEEEEEEE');
    }

  }


  handleMetaAndTitle() {
    let specialtyUrl = this?.route?.snapshot?.paramMap?.get('specialty')?.replace(/-/gi, ' ');
    let locationUrl = this?.route?.snapshot?.paramMap?.get('country')?.replace(/-/gi, ' ');


    // let country = this?.route?.snapshot?.paramMap?.get('country')

    let insuranceUrl = this?.route?.snapshot?.paramMap?.get('insuranceCompany')
    let city = this?.route?.snapshot?.paramMap?.get('city')
    let area = this?.route?.snapshot?.paramMap?.get('area')

    let insuranceUrlEnh = this?.route?.snapshot?.paramMap?.get('insuranceCompany')?.replace(/-/gi, ' ');
    // if (city && !area) {
    //   locationUrl = `${locationUrl} ${city}`
    // } else if (city && area) {
    //   locationUrl = `${locationUrl} ${city} ${area}`
    // }

    if (area != 'all-areas' && area != 'جميع-المناطق') {
      locationUrl = `${city} ${area}`
    } else if (city != 'all-governorates' && city != 'جميع-المحافظات') {
      locationUrl = `${city}`
    }

    if (insuranceUrl != 'all-insurance' && insuranceUrl != 'جميع-التأمينات') {
      if (this?.LangCode == 'ar') {
        locationUrl = `${locationUrl} لدى ${insuranceUrlEnh}`
      } else {
        locationUrl = `${locationUrl} from ${insuranceUrlEnh}`
      }
    }

    if (this?.LangCode == 'ar') {
      // if (locationUrl == 'jordan') {
      //   locationUrl = "الأردن"
      // }
      if (specialtyUrl == 'جميع التخصصات') {
        specialtyUrl = "تخصص"
      }
      this.app.updateTitleService(`أفضل دكتور ${specialtyUrl} في ${locationUrl} | حجز مجاني - تأكيد الحجز فورياً`);
      this.app.updateMetaService(`احجز اونلاين مجاناً مع أفضل دكتور ${specialtyUrl} في ${locationUrl}، اختر حسب التأمين أو اسم الدكتور أو سعر الكشفية، تقييمات حقيقية وموثّقة - حجز وتأكيد مجاني مع دفع لاحق في العيادة`);
      this.headerTwo = `اختر واحجز مع أفضل دكتور ${specialtyUrl} في ${locationUrl}`
    } else if (this?.LangCode == 'en') {
      if (specialtyUrl == 'all specialities') {
        specialtyUrl = "speciality"
      }
      this.app.updateTitleService(`Best ${specialtyUrl} doctor in ${locationUrl} | Book now for free`);
      this.app.updateMetaService(`Book online with best ${specialtyUrl} doctor in ${locationUrl}, select your preferred insurance company, doctor name, or price, real & verified reviews, book now for free and pay in clinic`);
      this.headerTwo = `Book your appointment with best ${specialtyUrl} doctor in ${locationUrl}`
    }
  }

  searchForDoctors() {
    this.app.showLoading();
    if (this.firstInit == false) {
      this.adjustUrl();
      // toAdjustEverySearch
    }

    this.service.searchDoctors(this.form.value).subscribe(
      res => {
        if (res.errorCode == 0) {
          this.handleMetaAndTitle();
          this.cd.markForCheck();
          const entity = this.addIsMoreAttrForServices(res.data.data)
          if (this.doctors.length) {


            let nextValues = entity;
            const totalRows = res.data.totalRows;
            let withLastValues = this.doctors.concat([...nextValues]);

            // if search result count less that current objects
            if (totalRows < withLastValues.length) {
              this.doctors = (nextValues);
              this.cd.detectChanges();
            } else {
              this.doctors = (withLastValues);
              this.cd.detectChanges();
            }
            this.isLoaded = true;
          } else {
            this.doctors = entity;
            this.cd.markForCheck();
          }
          this.totalResult = res.data.totalRows;
          if (this.doctors.length == 0) {
            if (res.data.data.length == 0) {
              if (this?.app?.getUserLanguage() == 'en') {
                this.toaster.info("Nothing Found");
              } else if (this?.app?.getUserLanguage() == 'ar') {
                this.toaster.info("لم يتم العثور على بيانات");
              }
            }
          }
        }
        this.app.dismissLoading();
      }
    )
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => this.addScrollListener(), 750)
    }
    this.firstInit = false
  }

  search() {
    this.app.showLoading();

    if (this.firstInit == false) {
      this.adjustUrl();
      // toAdjustEverySearch
    }

    this.get("pageSize").setValue(10);
    this.get("pageNumber").setValue(1);
    this.service.searchDoctors(this.form.value).subscribe(
      res => {
        if (res.errorCode == 0) {
          this.handleMetaAndTitle();
          const entity = this.addIsMoreAttrForServices(res.data.data)
          this.doctors = entity
          this.totalResult = res.data.totalRows;
          this.cd.detectChanges();
          if (this.doctors.length == 0) {
            if (res.data.data.length == 0) {
              if (this?.app?.getUserLanguage() == 'en') {
                this.toaster.info("Nothing Found");
              } else if (this?.app?.getUserLanguage() == 'ar') {
                this.toaster.info("لم يتم العثور على بيانات");
              }
            }
          }
        }
        this.app.dismissLoading();
      }
    )
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => this.addScrollListener(), 750)
    }
    this.firstInit = false
  }

  sortByChange(e) {
    if (!e.isUserInput) { return }

    let x = e.source.value

    switch (x) {
      case 1: {
        this.get("rate").setValue(1)
        this.get("priceRange").setValue(undefined)
        this.get("distance").setValue(undefined)
        this.search();
        break;
      }
      case 2: {
        this.get("rate").setValue(undefined)
        this.get("priceRange").setValue(2)
        this.get("distance").setValue(undefined)
        this.search();
        break;
      }
      case 3: {
        this.get("rate").setValue(undefined)
        this.get("priceRange").setValue(undefined)
        this.get("distance").setValue(2)
        this.search();
        break;
      }
    }
  }

  clearFilters() {
    this.get("searchText").setValue('');
    this.get("insuranceCompanyIds").setValue([]);
    this.get("gender").setValue(undefined);
    this.get("languageIds").setValue([]);
    // this.get("isIHospitalTeam").setValue(false);
    // this.get("longitude").setValue(null);
    // this.get("latitude").setValue(null);
    this.get("locationId").setValue(undefined);
    // this.get("rate").setValue(null);
    // this.get("priceRange").setValue(0);
    // this.get("distance").setValue(0);
    this.get("servicesIds").setValue([]);
    // this.formattedaddress = null
    // this?.get("locationPlaceholderNotMapped")?.setValue(undefined);
    // this.removeParamsFromUrl();
  }

  // Book Appointment Btn
  medicalServicePopUp = (doctor, MedicalServices) => {
    this.dialog.open(ShowServicesDialogComponent, {
      data: {
        res: MedicalServices,
        doctorId: doctor
      },
      width: '600px',
    })
  }

  async getLookUps() {
    await this.getAllLocations();
    await this.getMedicalService();
    await this.getHealthCareInsurance();
    await this.getLanguages();
    // if (isPlatformBrowser(this.platformId)) {
    // }
  }

  // lookUps
  getHealthCareInsurance = () => {
    this.service.getInsuranceCompanies({ pageSize: 9999, pageNumber: 1 }).subscribe(res => {
      this.healthCareInsurance = res.data.data;
    })
  }

  getLanguages = () => {
    this.service.getLanguages({ pageSize: 9999, pageNumber: 1 }).subscribe(
      res => {
        this.languages = res.data.data
      }
    )
  }

  getMedicalService = () => {
    this.service.getMedicalServices().subscribe(
      res => {
        // this.medicalServicesSSR = res.data
        this.medicalServices = res.data.filter(x => x.classification == 3)
        setTimeout(() => {
          this.checkUrlForParams();
        }, 200);
      }
    )
  }

  allLocations;
  allLocationsValues;
  getAllLocations = () => {
    this.service.getAllLocations().subscribe(res => {
      if (res.errorCode == 0) {
        // this.allLocations = res.data
        this.allLocations = res?.data?.map(item => {
          if (item?.parentName) {
            item.nameForSelect = `${item?.parentName} - ${item?.name}`
            return item
          } else {
            item.nameForSelect = item?.name
            return item
          }
        })
        this.cd.detectChanges();
      }
    })
  }
  // lookUps


  // gets 10 more docs on scroll
  onScrolling = () => {
    if (this.totalResult <= this.doctors.length || this?.app?.isLoading == true) { return }
    if (isPlatformBrowser(this.platformId)) {
      if (~~(Number($(window).scrollTop())) + Number($(window).height()) > Number($(this.document).height()) - 300) {
        this.removeScrollListener();
        this.app.showLoading();
        this.form.get('pageNumber')?.setValue(Number(this.form.get('pageNumber')?.value) + 1);
        this.searchForDoctors();
        // setTimeout(() => this.app.dismissLoading(), 750)
      }
    }
  }

  // removing params from url (old), now adjustUrl() fun handle it
  // removeParamsFromUrl() {
  //   this.router.navigate([], {
  //     queryParams: {
  //       'searchText': null,
  //       'longitude': null,
  //       'latitude': null,
  //       'insuranceCompanyIds': null,
  //       // 'MedicalServices': null,
  //       'specialist': null
  //     },
  //     queryParamsHandling: 'merge'

  //   });
  // }


  // returns true if string contains arabic letters
  isProbablyArabic(str: string): boolean {
    var Character
    for (var i = 0; i < str?.length; i++) {
      let c = str.codePointAt(i);
      if (c >= 0x0600 && c <= 0x06E0)
        return true;
    }
    return false;
  }

  // for not logged in popUp dialog
  notLoggedInDialog() {
    const dialogRef = this.dialog.open(LoginDialogComponent, {
      width: '350px',
      data: {},
    });
    dialogRef.afterClosed().subscribe(res => {
    });
  }

  // handle services being more than 5
  addIsMoreAttrForServices(data: any) {
    let x = data.map(item => {
      if (item?.medicalServices?.length <= 5) {
        return { ...item, isMedicalServicesOverSize: false };
      } else if (item?.medicalServices?.length > 5) {
        return { ...item, isMedicalServicesOverSize: true };
      }
    })
    return x
  }


  routeToBookingBasedOnClassification(Classification, haveThisService, doctor) {
    if (!this.app.getUserData()) {
      this.notLoggedInDialog();
      return
    }
    // classification 1 = home
    // classification 2 = online consult
    // classification 3 = clinic
    if (haveThisService == true) {
      let medicalService = doctor?.medicalServices?.find(x => x?.classification == Classification)
      switch (Classification) {
        case 3:
          this.routerToBookingActual(medicalService?.id, doctor?.id, doctor.userId)
          break;
        case 2:
          this.routerToBookingActual(medicalService?.id, doctor?.id, doctor.userId)
          break;
        case 1:
          this.routerToBookingActual(medicalService?.id, doctor?.id, doctor.userId)
          break;
      }
    }
  }

  routerToBookingActual(serviceId, hcpId, userId) {
    this.router.navigate(['/' + this?.app?.languageCode + '/booking'], {
      queryParams: {
        'serviceId': serviceId,
        'doctorId': hcpId,
        'hcpId': userId,
      }
    });
  }

}
